import { useMemo } from 'react';
import { useParams } from 'react-router';

import { useAppSelector } from '@/shared/hooks';

import { reportsModel } from '@/entities/reports';

import { ToothChart, toothChartModel } from '@/features/toothChart';

import styles from './PreviewToothChart.module.scss';

export const PreviewToothChart = () => {
  const { reportID } = useParams();
  const { toothItems } = useAppSelector(
    toothChartModel.selectors.selectToothChartItems(reportID as string, true),
  );
  const showUpperJaw = useAppSelector(
    reportsModel.selectors.selectPreviewSettingsShowTopJaw,
  );
  const showLowerJaw = useAppSelector(
    reportsModel.selectors.selectPreviewSettingsShowBottomJaw,
  );
  const blackAndWhiteMode = useAppSelector(
    reportsModel.selectors.selectPreviewSettingsBlackAndWhiteMode,
  );

  const filteredTeethItems = useMemo(
    () =>
      toothItems.filter((toothItem) => {
        if (!showUpperJaw) {
          return toothItem.isLowerJaw;
        }

        if (!showLowerJaw) {
          return !toothItem.isLowerJaw;
        }

        return true;
      }),
    [showLowerJaw, showUpperJaw, toothItems],
  );

  return (
    <ToothChart.Root className={styles.container}>
      <ToothChart.Grid
        showUpperJaw={showUpperJaw}
        showLowerJaw={showLowerJaw}
        isPreview
      >
        {filteredTeethItems.map((toothItem) => (
          <ToothChart.MetaItem
            key={toothItem.id}
            toothItem={toothItem}
            preview
            blackAndWhite={blackAndWhiteMode}
          />
        ))}
      </ToothChart.Grid>
    </ToothChart.Root>
  );
};
